import {Directive, ViewContainerRef} from '@angular/core';
import {MatSidenav} from '@angular/material/sidenav';

@Directive({
    selector: '[appDynamicAsideContent]',
})
export class DynamicAsideContentDirective {
    constructor(public viewContainerRef: ViewContainerRef,
                public aside: MatSidenav) {
    }
}
